module.exports = __webpack_public_path__ + "static/media/1023537.273d7d1c.png";